import { atom } from 'recoil';
import { Preferences } from './preferences.factory';

const prefsState = atom<Preferences | null>({
  key: 'preferences',
  default: null,
});

export default prefsState;
